import Button from "../../Components/Button";
import success from "../../assets/success.png";
import { useMyAccountContext } from "../../Contexts/MyAccountContext";
import { useEffect } from "react";

function Success() {
  const {
    type,
    navigate,
  } = useMyAccountContext();

  useEffect(()=>{
    if(type === ""){
      navigate("/my-account", { replace: true });
    }
  },[type])

  const handleBack=()=>{
    navigate("/my-account", { replace: true });
  }

  let title = "";
  let description = "";
  if(type === "email address"){
    title = "Verification email sent!";
    description = "A verification email consisting of verification link was sent to your email address";
  }else if(type === "mobile number"){
    title = "Mobile number updated successfully!";
    description = "Congratulations! Your mobile number has been successfully updated";
  }

  return (

    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        <div className="w-full h-[calc(100vh-165px)] sm:h-full flex flex-col items-center justify-center p-4 pt-[50px]">
          <div className="max-w-[400px] flex flex-col items-center justify-center">
            <img src={success} className="w-[75px] mb-4 text-center" alt="success"/>
            <p className="text-[#1F2328] text-xl text-center font-bold mb-4">
              {title}
            </p>
            <p className="text-[#60656D] text-center mb-4">
              {description}
            </p>
          </div>
        </div>
        <div className="flex w-full p-4 mt-auto">
          <Button
            className="h-12 w-full rounded-xl text-white"
            onClick={handleBack}
          >
            Ok
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Success;